import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { MatDialogTitle } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { AraButtonComponent } from '../ara-button/ara-button.component';

/**
 * Wiederverwendbarer, ziehbarer Dialog-Kopf: Titel links, Schließen-X rechts.
 *
 * Ersetzt die zuvor in zahlreichen Dialogen identisch kopierte `.dialog-header`-Zeile
 * (Titel + Close-Button) inklusive zugehörigem SCSS. Den eigentlichen `close()`-Aufruf
 * entscheidet der Aufrufer über das `closed`-Event (z.B. `(closed)="close(false)"`).
 */
@Component({
	selector: 'ara-dialog-header',
	imports: [CdkDrag, CdkDragHandle, MatDialogTitle, MatIcon, AraButtonComponent],
	templateUrl: './ara-dialog-header.component.html',
	styleUrl: './ara-dialog-header.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AraDialogHeaderComponent {
	/** Bereits übersetzter Titeltext. */
	readonly title = input.required<string>();
	/** Optionale, bereits übersetzte Subzeile unter dem Titel (z.B. Liegenschafts-Adresse). */
	readonly subtitle = input<string>();
	/** Sperrt den Schließen-Button (z.B. während eines laufenden Requests). */
	readonly closeDisabled = input<boolean>(false);
	/** Feuert beim Klick auf das Schließen-X. */
	readonly closed = output<void>();
}
